import React, { FunctionComponent } from 'react';
import useStyles from './BlogTopCategories.css';
import { cn } from '@admitkard/ccl';
import { BlogCategoryContent } from 'components/Blog/blogTypes';
import { useRouter } from 'next/router';
import {BlogTopCategoriesSecondary } from 'components/Blog/BlogTopCategoriesSecondary';
import { ALLOWED_CATEGORY_SLUGS } from 'components/Blog/BlogUtils';
interface BlogTopCategoriesProps {
  categories: BlogCategoryContent[];
}

export const BlogTopCategories: FunctionComponent<BlogTopCategoriesProps> = (props) => {
  const classes = useStyles();
  const router = useRouter();
  const heroCategorySlug  = ALLOWED_CATEGORY_SLUGS[0];
  const heroCategory = props.categories.find((category) => {
    return category.slug === heroCategorySlug;
  });
  const restCategories = props.categories.filter((category) => {
    return category.slug !== heroCategorySlug;
  });

  const redirectToCategoryPage = (slug: string) => {
    if(slug) {
      router.push(`/blog/categories/${slug}`);
    }
  };

  return (
    <>
      <div className={classes.root}>
        <h1>Top Categories</h1>
        <div className={classes.categoriesContainer}>
          <div onClick={() => redirectToCategoryPage(heroCategory?.slug || '')} className={cn(classes.categoriesItemPrimary)}>
            <div className={cn(classes.categoryItemPrimary)}>
              <div className={cn(classes.categoriesImgContainerPrimary)}>
                <img className={classes.imgContainer} src={heroCategory?.categoryCustomFields?.featuredImage?.sourceUrl || ''}/>
              </div>
              <div className={cn(classes.categoriesDetailsContainerPrimary)}>
                <div className={cn(classes.categoriesDetailTiltlePrimary)}>{heroCategory?.name}</div>
                <div className={cn(classes.categoriesDetailSubtitlePrimary)}>{heroCategory?.seo?.description}</div>
              </div>
            </div>
          </div>
          <div className={cn(classes.categoriesItemSecondary)}>
            {restCategories.map((category: BlogCategoryContent) => (
              <BlogTopCategoriesSecondary category={category}
                key={category.id}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};
